import { c as _c } from "react/compiler-runtime";
import { QuotedTweet, TweetActions, TweetBody, TweetHeader, TweetInfo, TweetInReplyTo, TweetMedia, TweetReplies } from "react-tweet";
import type { EnrichedTweet } from "./ExpandableTweetPreview.types";
export default function ExpandedTweetContent(t0) {
  const $ = _c(21);
  const {
    tweet
  } = t0;
  let t1;
  let t2;
  if ($[0] !== tweet) {
    t1 = <TweetHeader tweet={tweet} />;
    t2 = tweet.in_reply_to_status_id_str ? <TweetInReplyTo tweet={tweet} /> : null;
    $[0] = tweet;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  let t3;
  let t4;
  if ($[3] !== tweet) {
    t3 = <TweetBody tweet={tweet} />;
    t4 = typeof tweet.mediaDetails?.length === "number" && tweet.mediaDetails.length > 0 ? <TweetMedia tweet={tweet} /> : null;
    $[3] = tweet;
    $[4] = t3;
    $[5] = t4;
  } else {
    t3 = $[4];
    t4 = $[5];
  }
  let t5;
  if ($[6] !== tweet.quoted_tweet) {
    t5 = tweet.quoted_tweet ? <QuotedTweet tweet={tweet.quoted_tweet} /> : null;
    $[6] = tweet.quoted_tweet;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  let t7;
  let t8;
  if ($[8] !== tweet) {
    t6 = <TweetInfo tweet={tweet} />;
    t7 = <TweetActions tweet={tweet} />;
    t8 = <TweetReplies tweet={tweet} />;
    $[8] = tweet;
    $[9] = t6;
    $[10] = t7;
    $[11] = t8;
  } else {
    t6 = $[9];
    t7 = $[10];
    t8 = $[11];
  }
  let t9;
  if ($[12] !== t1 || $[13] !== t2 || $[14] !== t3 || $[15] !== t4 || $[16] !== t5 || $[17] !== t6 || $[18] !== t7 || $[19] !== t8) {
    t9 = <>{t1}{t2}{t3}{t4}{t5}{t6}{t7}{t8}</>;
    $[12] = t1;
    $[13] = t2;
    $[14] = t3;
    $[15] = t4;
    $[16] = t5;
    $[17] = t6;
    $[18] = t7;
    $[19] = t8;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  return t9;
}